<h5 class="mt-1 text-center text-uppercase">Caja de Inversión Por Acciones</h5>

<div *ngIf="shareSaving && shareSaving.status !== 'pending'">
    <div *ngIf="shareSavingsUserData; else contract">
        <hr>
        <div class="row blocked">
            <div class="col-md-4">
                <mat-form-field>
                    <input matInput placeholder="Número De Colaborador:"
                        [value]="currentEmployee.workInformation.employeeNumber" readonly>
                </mat-form-field>
            </div>

            <div class="col-md-4">
                <mat-form-field>
                    <input matInput placeholder="Casa de Bolsa" [value]="shareSavingsUserData.investmentType"
                        type="text">
                </mat-form-field>
            </div>

            <div class="col-md-4">
                <mat-form-field>
                    <input matInput placeholder="Num. Contrato" [value]="shareSavingsUserData.contractNumber"
                        type="text">
                </mat-form-field>
            </div>
        </div>

        <div class="row blocked">
            <div class="col-md-4">
                <mat-form-field>
                    <input matInput placeholder="RFC:" [value]="currentEmployee.taxationIdentificationNumber"
                        type="text">
                </mat-form-field>
            </div>
            <div class="col-md-4">
                <mat-form-field>
                    <input matInput placeholder="Importe a Ahorrar:" [value]="shareSaving.contributionAmount"
                        type="text">
                </mat-form-field>
            </div>
        </div>

        <app-header headerText="Datos del Ciclo" [small]="true"></app-header>

        <div class="row blocked">

            <div class="col-md-4">
                <mat-form-field>
                    <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
                    <input matInput placeholder="Ahorro de Acciones Máximo:"
                        [value]="(shareSavingsParameters.maxMonto | number: '.2-2')" type="text">
                </mat-form-field>
            </div>

            <div class="col-md-4">
                <mat-form-field>
                    <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
                    <input matInput placeholder="Ahorro de Acciones Mínimo:"
                        [value]="(shareSavingsParameters.minMonto | number: '.2-2')" type="text">
                </mat-form-field>
            </div>

        </div>

        <app-header headerText="Aportaciones:" [small]="true"></app-header>
        <div class="row" onpaste="return false" >

            <div class="col-md-4" [ngClass]="{blocked: activeUser}">

                <mat-form-field>
                    <span matPrefix>$&nbsp;</span>
                    <input matInput placeholder="Importe de Ahorro Solicitado:"
                        [ngModel]="shareSaving.contributionAmount | number: '1.'"
                        (ngModelChange)="shareSaving.contributionAmount=currencyInputChanged($event)" appOnlyNumber
                        [allowDecimals]="true" type="text" [formControl]="formControlContributionAmount" required>
                    <mat-error
                        *ngIf="!formControlContributionAmount.hasError('max') && formControlContributionAmount.hasError('min')">
                        El importe de ahorro debe de ser mayor al mínimo</mat-error>
                    <mat-error
                        *ngIf="!formControlContributionAmount.hasError('min') && formControlContributionAmount.hasError('max')">
                        El importe de ahorro debe de ser menor al máximo </mat-error>
                </mat-form-field>

            </div>

            <div class="col-md-4 blocked">
                <mat-form-field>
                    <span class="matPrefixDisabled" matPrefix></span>
                    <input matInput placeholder="Número de Cuotas de Descuento:"
                        [value]="(shareSavingsParameters.cuotas)" type="text" disabled>
                </mat-form-field>
            </div>
            <div *ngIf="!activeUser" class="col-md-4 center-vertically " [matTooltip]="calculateMessage" aria-label="mensaje"
                matTooltipPosition="above" [matTooltipDisabled]="!calculateDisabled()">
                <button style="margin-bottom: 1.2-25em;" class="btn btn-block btn-primary"
                    [disabled]="calculateDisabled()" (click)="calculate()">Calcular Descuento</button>
            </div>


        </div>
        <div class="row blocked" *ngIf="!calculateDisabled()">

            <div class="col-md-4">
                <mat-form-field>
                    <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
                    <input matInput placeholder="Descuento por Nómina" [value]="(shareSaving.payment | number: '.2-2')"
                        type="text">
                </mat-form-field>
            </div>
            <div class="col-md-8" *ngIf="paymentMessageError.length > 1">
                <div class="alert alert-danger">{{ paymentMessageError }}</div>
            </div>


        </div>

        <div *ngFor="let b of shareSaving.beneficiaries.values()">

            <app-header [headerText]="beneficiariesTitles[b.index]" [small]="true"></app-header>

            <div class="row" >

                <div class="col-md-4" [ngClass]="{blocked: activeUser}">
                    <mat-form-field>
                        <input matInput placeholder="Nombre(s):" type="text"
                            [formControl]="beneficiariesControls[b.index][0]">
                        <mat-error *ngIf="!beneficiariesControls[b.index][0].valid">Debe de ingresar al menos un nombre
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-md-4" [ngClass]="{blocked: activeUser}">
                    <mat-form-field>
                        <input matInput placeholder="Apellido Paterno:" type="text"
                            [formControl]="beneficiariesControls[b.index][1]">
                        <mat-error *ngIf="!beneficiariesControls[b.index][1].valid">Debe de ingresar un apellido
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-md-4" [ngClass]="{blocked: activeUser}">
                    <mat-form-field>
                        <input matInput placeholder="Apellido Materno:" type="text"
                            [formControl]="beneficiariesControls[b.index][2]">
                        <mat-error *ngIf="!beneficiariesControls[b.index][2]">Debe de ingresar un apellido</mat-error>
                    </mat-form-field>
                </div>

            </div>

            <div class="row">

                <div class="col-md-4" [ngClass]="{blocked: activeUser}">
                    <mat-form-field>
                        <input matInput placeholder="Parentesco:" type="text"
                            [formControl]="beneficiariesControls[b.index][3]">
                        <mat-error *ngIf="!beneficiariesControls[b.index][3].valid">Debe ingresar una relación
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-4" [ngClass]="{blocked: activeUser}">
                    <mat-form-field>
                        <input style="width:95%;" matInput placeholder="Porcentaje:" type="number"
                            [formControl]="beneficiariesControls[b.index][4]" min="0"
                            onkeypress="return event.charCode >= 48 && event.charCode <= 57">
                        <span matSufix>%</span>
                        <mat-error *ngIf="!beneficiariesControls[b.index][4].valid">Debe ingresar un porcentaje válido
                        </mat-error>
                    </mat-form-field>
                </div>

                <div *ngIf="(b.index > 0 && b.index === beneficiariesControls.length - 1) && !activeUser"
                    class="col-md-4 bottom-vertically">
                    <button class="btn btn-block btn-primary" (click)="removeLastBeneficiary()">Eliminar
                        Beneficiario</button>
                </div>

            </div>

        </div>

        <div *ngIf="beneficiariesControls.length < 3 && !activeUser" class="my-5 row">
            <div class="col-md-4 offset-md-8">
                <button class="btn btn-block btn-primary" (click)="addBeneficiary()">Agregar otro Beneficiario</button>
            </div>
        </div>

        <div class="my-4 row" *ngIf="!activeUser">
            <div class="col-md-4 offset-md-4">
                <!-- TODO Mostrar confirmación antes de cancelar - REVISAR-->
                <button class="btn btn-outline-secondary btn-block" (click)="cancel(0, 0)">Cancelar</button>
            </div>
            <div class="col-md-4 center-vertically " [matTooltip]="paymentMessageSave" aria-label="mensaje"
                matTooltipPosition="above" [matTooltipDisabled]="!calculateDisabled()">
                <!-- TODO Mostrar confirmación antes de guardar -->
                <button class="btn btn-block btn-primary" [disabled]="calculateDisabled() || !paymentValid"
                    (click)="submitSubscription()">Guardar</button>
            </div>

        </div>
    </div>

    <ng-template #contract>
        <div class="alert alert-info mt-5">
            <h4 class="mt-1 text-center text-uppercase">En este momento no cuentas con un contrato vigente</h4>
        </div>

        <div class="row mt-4">
            <div class="col-sm-6 col-md-4 offset-md-1 py-4 my-5 text-center">
                <label> Para tramitar tu contrato descarga la siguiente información: </label>
            </div>

            <div class="col-sm-12 col-md-3 offset-md-1 py-2 text-center">
                <button class="btn-block pt-3" mat-stroked-button color="primary" (click)="descargarInfo()">
                    <img class="img-fluid img-thumbnail mini" src="{{plantilla}}" /><br>
                    <label> Descargar </label>
                </button>
            </div>

        </div>


    </ng-template>

</div>

<div *ngIf="shareSavingsUserData && shareSaving && shareSaving.status == 'pending'">
    <!--div class="alert alert-info mt-5">
        <h4 class="mt-1 text-center text-uppercase">Descarga la Carta compromiso</h4>
    </div-->
    <hr>
    <div class="row mt-4">
        <div class="col-sm-10 col-md-10 offset-md-1 mt-2 text-center">
            <lib-contract-state [employeeNumber]="currentEmployee.workInformation.employeeNumber" [ssID]="shareSaving.ssID" ></lib-contract-state>
        </div>
    </div>


</div>